import styled from "styled-components";
import { Calendar } from "../../../../Assets/icons";

export const DatepickerConatiner = styled.div`
    align-items: center;
    border: 2px solid #006560;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    gap: 4px;
    padding: 0 8px;

    span{
        color: #333;
        display: none;
        font-weight: 600;

        @media (min-width: 720px) {
            display: flex;
            font-size: 16px;
        }
        @media (orientation: landscape) and (max-width: 1080px){
            display: none;
            font-size: 14px;
        }
    }

    &:hover{
        background: #F2F2F2;
        border-color: #33CC99;
    }
`;
 
export const DateInput = styled.input`
    align-items: center;
    background: url(${Calendar}) no-repeat center / 24px 24px;
    border: none;
    cursor: pointer;
    display: flex;
    height: 30px;
    justify-content: flex-end;
    outline: none;
    text-decoration: none;
    width: 30px;

    @media (min-width: 720px) {
        background: url(${Calendar}) no-repeat center / 36px 36px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        background: url(${Calendar}) no-repeat center / 28px 28px;
    }

    &::-webkit-calendar-picker-indicator{
        color: #333;
        cursor: pointer;
        height: 25px;
        visibility: hidden;
        width: 25px;
    }
`;